export default __webpack_public_path__ + "static/media/logo.ae9b9bc7.png";